import { createFormHookContexts } from "@tanstack/react-form";

// Create form contexts for type-safe composition
export const { fieldContext, formContext, useFieldContext } =
  createFormHookContexts();
